import { handleSessionError } from './authService';
import { API_BASE_URL } from '../../config/api';

export interface StatisticsData {
  total_users: number;
  active_users: number;
  blocked_users: number;
  trial_users: number;
  paid_users: number;
  expired_users: number;
  total_calculations: number;
  calculations_today: number;
  total_revenue: number;
  revenue_this_month: number;
  // נתונים נוספים שהשרת מחזיר
  meta?: {
    total_admins: number;
    total_explanations: number;
    active_explanations: number;
    recent_activity_30_days: number;
  };
}

export interface ApiResponse<T> {
  res: 'OK' | 'NOK';
  msg: string;
  data: T;
  error_code?: string;
}

// Helper function להכנת FormData (דפוס אחיד)
const createFormData = (data: Record<string, any>): FormData => {
  const formData = new FormData();

  // הוספת session token (חובה!)
  const sessionToken = localStorage.getItem('backoffice_session_id');
  if (sessionToken) {
    formData.append('session_token', sessionToken);
  }

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value.toString());
    }
  });
  return formData;
};

// Helper function לטיפול בresponse עם Token Expiry
const handleApiResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();

  // בדיקת session expiry
  if (handleSessionError(result)) {
    throw new Error('Session expired - redirecting to login');
  }

  return result;
};

class StatisticsService {
  async getStatistics(): Promise<StatisticsData> {
    try {
      const sessionToken = localStorage.getItem('backoffice_session_id');

      if (!sessionToken) {
        throw new Error('No session token found');
      }

      // יצירת FormData (לא JSON!) - דפוס אחיד בפרויקט
      const formData = createFormData({});

      // console.log('Fetching statistics from server...');

      const response = await fetch(`${API_BASE_URL}/Api/service/backoffice/get_statistics`, {
        method: 'POST',
        body: formData // FormData חובה!
      });

      const result = await handleApiResponse(response);

      // console.log('Statistics API response:', result);

      if (result.res === 'NOK') {
        throw new Error(result.msg || 'Failed to fetch statistics');
      }

      return result.data;

    } catch (error) {
      console.error('Statistics service error:', error);
      throw error;
    }
  }
}

export const statisticsService = new StatisticsService();